<template>
  <li class="flex items-center justify-between w-full gap-twentyFive px-thirtyFive py-base overflow-hidden">
    <div class="flex justify-between gap-twentyFive">
      <CheckboxSkeleton pulse />
      <TextSkeleton
        :characters="35"
        pulse
      />
    </div>
    <TextSkeleton
      :characters="23"
      pulse
    />
  </li>
</template>

<script>
import TextSkeleton from '@/components/library/skeletons/TextSkeleton.vue';
import CheckboxSkeleton from '@/components/library/skeletons/CheckboxSkeleton.vue';

export default {
  components: { TextSkeleton, CheckboxSkeleton },
};
</script>
